<template>
  <v-container fill-height
               fluid
               grid-list-xl>
    <v-layout justify-center
              wrap>
      <v-flex xs12 md10>
        <material-card :color="getTitleColorStore"
                       :title="$t('menu_my_education')"
                       :text="$t('my_education.subtitle')">
          <ProgressBar :loading="loading" color="deep-purple accent-4" />
          <template>
            <v-container grid-list-md>
              <v-layout row wrap>
                <MyPrograms :loading="setLoaderPO"></MyPrograms>
                <MySeminars :loading="setLoaderSeminari"></MySeminars>
              </v-layout>
            </v-container>
          </template>

        </material-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>



<script>
  import MyPrograms from './my_education_components/MyPrograms.vue';
  import MySeminars from './my_education_components/MySeminars.vue';
  import { mapGetters } from 'vuex';
  import ProgressBar from '../Common/Components/MyToolbarProgressBar.vue';

  export default {
    name: 'MyEducationView',
    computed: {
      ...mapGetters('app', { getTitleColorStore: 'getTitleColor' }),
      loading() {
        return this.loadingPO || this.loadingSeminare;
      }
    },

    data() {
      return {
        loadingPO: false,
        loadingSeminare: false,
        po: []
      }
    },

    methods: {
      setLoaderPO(isLoading) {
        this.loadingPO = isLoading;
      },

      setLoaderSeminari(isLoading) {
        this.loadingSeminare = isLoading;
      },
    },

    components: {
      MyPrograms, MySeminars, ProgressBar
    }


  }
</script>



// WEBPACK FOOTER //
// VueSrc/Education/MyEducationView.vue